module.exports = __webpack_public_path__ + "img/offers.weekly.3145c8aa.png";